var _defs, _rect, _line, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew272({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 2.8,
    y: 6.76,
    width: 10.38,
    height: 2.49
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.18,
    y1: 6.85,
    x2: 2.8,
    y2: 9.24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.57,
    cy: 8.05,
    r: 1.07
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.43,
    cy: 8.05,
    r: 1.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew272);
export default __webpack_public_path__ + "static/media/Symbolpack_New_272.68b799d45fe3e987f275287f4219f147.svg";
export { ForwardRef as ReactComponent };